import {Component, computed, input} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/input'
import {MatIcon} from '@angular/material/icon'
import {MatOption} from '@angular/material/core'
import {MatSelect} from '@angular/material/select'
import {swedenCountyList} from '../../../types'
import {BaseComponent} from '../base.component'

@Component({
  selector: 'spb-country-select',
  imports: [
    FormsModule,
    MatError,
    MatFormField,
    MatIcon,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix
  ],
  templateUrl: './country-select.component.html',
  styleUrl: './country-select.component.scss',
  providers: [{provide: BaseComponent, useExisting: CountrySelectComponent}]
})
export class CountrySelectComponent extends BaseComponent {
  public label = input<string>('Land')

  public disabled = input<boolean>(false)

  public required = input<boolean>(false)

  public excluded = input<string[]>([])

  public exclude = computed(() => {
    return this.excluded().filter(s => s !== this.model()!)
  })

  // 2 characters [A-Z][A-Z] e.g. FI, SE, US.
  protected readonly swedenCountyList = swedenCountyList
}
